/** paragraph break */
export const PBR = '\n\n'

/** HTML line break */
export const LBR = '<br>'

export const SECTION_START = '===============  \n'

export const NO_INFO = '[no information]'
